import * as React from 'react';

import type { OrganizationSearchProps } from './OrganizationSearch.types';

import styles from './OrganizationSearch.module.css';

const OrganizationSearch = React.memo(
  ({
    searchQuery,
    onSearchChange,
    listboxId,
    activeDescendant,
    isOpen,
  }: Readonly<OrganizationSearchProps>): React.ReactElement => {
    return (
      <input
        id="org-switcher-search"
        type="text"
        role="combobox"
        aria-expanded={isOpen}
        aria-controls={listboxId}
        aria-activedescendant={activeDescendant}
        aria-autocomplete="list"
        placeholder="Search"
        value={searchQuery}
        onChange={onSearchChange}
        className={styles.searchInput}
        data-testid="organization-search"
      />
    );
  }
);

OrganizationSearch.displayName = 'OrganizationSearch';

export { OrganizationSearch };
